import mySuxApi from '../services/dataSources/mySuxApi';

// constants
import { config } from '../config';

// actions
// import { pushEventQueue } from './cardEvents';


export const bookDeliveryDate =
(orderIdx, selectedDate, cardId, groupId, pushQueue, queueMessage) =>
(dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const body = {
    cardId,
    orderIdx,
    userGuid,
    delSchedIdx: selectedDate.delSchedIdx,
    notes: '',
    requestedDeliveryDate: selectedDate.delDate.format('YYYY-MM-DD'),
    groupId,
    Queue: !!parseInt(queueMessage, 10),
    selectedDate: {
      ...selectedDate,
      delDate: selectedDate.delDate.format('YYYY-MM-DD')
    }
  };

  return mySuxApi.post(`${config.URLS.MY_SOFOLOGY_API}${userGuid}/BookDelivery/${cardId}/${userId}`, body)
    .then((res) => {
      // if (!!parseInt(pushQueue, 10)) pushEventQueue(groupId); // no longer push, handles on backend
      return res;
    })
    .catch(e => console.error(e, `App failed to Book Delivery: ${orderIdx} for ${cardId}`));
};


export const submitDeliveryInstructions =
(cardId, orderId, deliveryInstructionsRequired, deliveryInstructions,
  groupId, pushQueue, queueMessage) =>
(dispatch, getState) => {
  const { userGuid, userId } = getState().user;
  const url = `${config.URLS.MY_SOFOLOGY_API}${userGuid}/BookDelivery/SetDeliveryNotes/${orderId}/${userId}`;
  const body = {
    UserGuid: userGuid,
    OrderIdx: orderId,
    DeliveryNotes: deliveryInstructionsRequired ? deliveryInstructions : '',
    CardId: cardId,
    GroupId: groupId,
    Queue: queueMessage
  };

  return mySuxApi.post(url, body)
    .then((res) => {
      // if (!!parseInt(pushQueue, 10)) pushEventQueue(groupId); // no longer needed handled on back end
      return res;
    })
    .then(response => response.data)
    .catch((error) => {
      console.error(error, 'Failed to submit delivery instructions');
    });
};



// WEBPACK FOOTER //
// ./src/actions/delivery.js